module.exports = __webpack_public_path__ + "img/behandel0.c990d0b8.jpeg";